import { useEffect, useState } from "react";
import { Doughnut } from "react-chartjs-2";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend);

const GraficoClientesTop20 = ({ datos }) => {
  const [agrupado, setAgrupado] = useState([]);

  const limpiarMonto = (valor) => {
    if (typeof valor !== "string") valor = String(valor);
    return parseFloat(valor.replace(/\$/g, "").replace(/,/g, "")) || 0;
  };

  useEffect(() => {
    const agrupadoPorCliente = {};

    datos.forEach((d) => {
      const razon = d.razon_social;
      const total = limpiarMonto(d.total);
      if (!agrupadoPorCliente[razon]) {
        agrupadoPorCliente[razon] = 0;
      }
      agrupadoPorCliente[razon] += total;
    });

    const resultado = Object.entries(agrupadoPorCliente)
      .map(([razon_social, total]) => ({ razon_social, total }))
      .sort((a, b) => b.total - a.total)
      .slice(0, 20);

    setAgrupado(resultado);
  }, [datos]);

  const chartData = {
    labels: agrupado.map((d) => d.razon_social),
    datasets: [
      {
        data: agrupado.map((d) => d.total),
        backgroundColor: [
          "#FF6384", "#36A2EB", "#FFCE56", "#4BC0C0",
          "#9966FF", "#FF9F40", "#D4A5A5", "#99D98C",
          "#FF6F61", "#8B5CF6", "#3B82F6", "#F59E0B",
          "#10B981", "#EF4444", "#6366F1", "#EC4899",
          "#22D3EE", "#FBBF24", "#A78BFA", "#4ADE80"
        ]
      }
    ]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { position: "right" }
    }
  };

  return (
    <div className="mt-5" style={{ height: "450px", maxWidth: "800px", margin: "0 auto" }}>
      <h5 className="text-center mb-3">Top 20 Clientes por Venta Total</h5>
      <Doughnut data={chartData} options={options} />
    </div>
  );
};

export default GraficoClientesTop20;
